import { render } from "./ExpenseReceiptsPageShell.vue?vue&type=template&id=10cad41d&scoped=true"
import script from "./ExpenseReceiptsPageShell.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptsPageShell.vue?vue&type=script&lang=js"

import "./ExpenseReceiptsPageShell.vue?vue&type=style&index=0&id=10cad41d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cad41d"]])

export default __exports__